import { SurveyModel } from 'survey-core';

export const getFirstQuestionWithError = (survey: SurveyModel) => {
  for (const question of survey.getAllQuestions()) {
    if (question.hasErrors() && question.isVisible && question.isParentVisible)
      return question;
  }
};
